import { render } from "./NavigationTop.vue?vue&type=template&id=2c4598fa&scoped=true"
import script from "./NavigationTop.vue?vue&type=script&lang=js"
export * from "./NavigationTop.vue?vue&type=script&lang=js"

import "./NavigationTop.vue?vue&type=style&index=0&id=2c4598fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4598fa"]])

export default __exports__